<template>
  <div align="center" class="wrapper">
    <ContactUsHeader />
    <div class="block-center mt-xl wd-xl">
      <!-- START panel-->
      <div class="panel panel-dark panel-flat">
        <div class="panel-body" v-show="!resetFeedback">
          <p class="text-center pv"><strong>Reset Password</strong></p>
          <p v-if="!linkExpired">Enter your email to receive instructions on how to reset your password.</p>
          <p v-if="linkExpired" class="text-red">
            <strong>Your reset password link has expired. Please request a new one.</strong>
          </p>

          <form role="form" class="mb-lg" @submit.prevent="validateAndSubmitResetPassword" novalidate >
            <div class="form-group has-feedback" v-bind:class="{ 'has-error': emailError }">
              <input v-model="email" id="signupInputEmail1" type="email"
              placeholder="Enter email" autocomplete="off" required class="form-control">
              <em class="form-icon icon-envelope"></em>
              <span id="helpBlock2" class="help-block">{{ emailError }}</span>
            </div>

            <button type="submit" class="btn btn-block btn-default btn-lg mt-xl">Reset password</button>

            <div class="form-group has-feedback" v-bind:class="{ 'has-error': resetPasswordError }">
              <strong id="helpBlock6" class="help-block">{{ resetPasswordError }}</strong>
            </div>
          </form>
        </div>

        <div class="panel-body" v-if="resetFeedback">
          <p>
            <strong id="helpBlock7">Password Reset Email Sent.</strong>
             <br/>
             If you entered a registered email in our system, we’ve sent you a link to reset your password. If you don’t receive an email within 5 minutes (and perhaps checked your spam and /or tried again to make sure email entered correctly),
             <br/>
             <strong id="helpBlock8">then please contact us at info@calvertimpact.org or 800.248.0337.</strong>
           </p>
        </div>

      </div>

      <!-- END panel-->
    </div>
  </div>
</template>

<script>
import {
      mapActions,
    } from 'vuex';
import ContactUsHeader from './ContactUsHeader';

export default {
  name: 'resetPassword',
  components: {
    ContactUsHeader,
  },
  created() {
    const { email, resetEmail } = this.$route.query;
    if (resetEmail) {
      this.email = decodeURIComponent(email) || '';
    }
  },
  data() {
    return {
      resetMessage: "Password Reset Email Sent. If you entered a registered email in our system, we've sent you a link to reset your password. If you don't receive an email within 5 minutes (and perhaps checked your spam and/or tried again to make sure email entered correctly), then please contact us at info@calvertimpact.org or 800.248.0337.",
      email: '',
      emailError: '',
      resetPasswordError: '',
      linkExpiredError: '',
      resetFeedback: false,
    };
  },
  computed: {
    linkExpired() {
      return !!this.$route.query.resetEmail;
    },
  },
  methods: {
    ...mapActions('authentication', [
      'forgotPassword',
    ]),
    resetValidations() {
      this.emailError = '';
      this.resetPasswordError = '';
    },
    async validateAndSubmitResetPassword() {
      this.resetValidations();
      if (!this.validateEmail(this.email)) {
        return false;
      }
      const { email } = this;
      try {
        const { data } = await this.forgotPassword({ email });
        this.resetFeedback = !!data;
        return true;
      } catch (error) {
          // TODO: stop using error
        this.resetPasswordError = error.message;
      }

      return false;
    },
    validateEmail(email) {
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      if (!regex.test(email)) {
        this.emailError = 'Please, enter a valid email';
        return false;
      }
      return true;
    },
  },
};
</script>

<style>
  body {
    background-color: #fff;
  }

  /* Global mobile overrides - must be non-scoped to override theme.scss */
  @media (max-width: 1024px) {
    .wrapper {
      padding: 0 !important;
      margin: 0 !important;
      align-items: stretch !important;
    }

    .wrapper[align="center"] {
      display: flex !important;
      flex-direction: column !important;
      min-height: 100vh !important;
    }

    .block-center.mt-xl {
      margin: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    .block-center.mt-xl.wd-xl {
      margin: 0 !important;
      width: 100% !important;
    }

    .panel-dark.panel-flat {
      margin: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      flex: 1 !important;
    }
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wd-xl {
    width: 360px;
    max-width: 100%;
  }

  .text-red {
    color: #a94442;
  }

  .panel-body {
    padding: 15px 25px;
  }

  .form-icon {
    position: absolute;
    top: 10px;
    right: 12px;
  }

  /* Mobile responsive styles */
  @media (max-width: 1024px) {
    .panel-body {
      padding: 30px 24px !important;
    }

    .form-control {
      font-size: 18px !important;
      height: 50px !important;
      padding: 12px 16px !important;
    }

    .form-icon {
      font-size: 18px !important;
      top: 15px !important;
      right: 16px !important;
    }

    .btn-lg {
      font-size: 20px !important;
      padding: 16px 24px !important;
      height: auto !important;
    }

    .mt-xl {
      margin-top: 20px !important;
    }

    .form-group {
      margin-bottom: 20px;
    }

    .help-block {
      font-size: 15px;
    }

    p {
      margin-bottom: 12px;
      margin-top: 12px;
      font-size: 16px;
    }

    p:first-child {
      margin-top: 0;
    }

    p.text-center {
      margin-bottom: 12px;
    }

    p strong {
      font-size: 16px;
    }

    .text-red {
      font-size: 16px;
    }

    .pv {
      padding-top: 12px !important;
      padding-bottom: 12px !important;
    }

    .text-center.pv strong {
      font-size: 18px;
    }
  }

  @media (max-width: 480px) {
    .panel-body {
      padding: 24px 20px !important;
    }

    .form-control {
      font-size: 17px !important;
      height: 48px !important;
    }

    .form-icon {
      font-size: 17px !important;
      top: 14px !important;
    }

    .btn-lg {
      font-size: 19px !important;
      padding: 15px 22px !important;
    }

    p {
      font-size: 15px;
    }

    p strong {
      font-size: 15px;
    }

    .text-center.pv strong {
      font-size: 17px;
    }
  }

  /* Extra small devices */
  @media (max-width: 360px) {
    .panel-body {
      padding: 20px 16px !important;
    }

    .form-control {
      font-size: 16px !important;
      height: 46px !important;
    }

    .btn-lg {
      font-size: 18px !important;
      padding: 14px 20px !important;
    }

    p {
      font-size: 14px;
    }

    p strong {
      font-size: 14px;
    }

    .text-center.pv strong {
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?d269593e